import * as dialogComponentLocales from "../components/Dialog/locales";
import * as formFieldLocales from "../components/Form/locales";
import * as hDialogSelectLocales from "../components/HDialogSelect/locales";
import * as hSpinnerLocales from "../components/HSpinner/locales";
import * as stepButtonsLocales from "../components/StepButtons/locales";
import * as onfidoLocales from "../features/onfido/locales";
import * as hAddressPickerLocales from "../components/HAddressPicker/locales";

const componentsLocales = {
  ...dialogComponentLocales.it,
  ...stepButtonsLocales.it,
  ...formFieldLocales.it,
  ...hDialogSelectLocales.it,
  ...onfidoLocales.it,
  ...hSpinnerLocales.it,
  ...hAddressPickerLocales.it,
};

const errorMessages = {
  sessionExpired: {
    title: "Sessione Scaduta",
    message:
      "Per garantire la protezione dei tuoi dati, la sessione si interrompe automaticamente dopo pochi minuti di inattività. Ma non preoccuparti, potrai ricominciare esattamente da dove l’hai interrotta.",
    buttonText: "Riprendi",
  },
  notFoundPage: {
    title: "Pagina non trovata",
    message: "Oops. Questa pagina non esiste.",
  },
  unauthorizedAccessPage: {
    title: "Accesso non autorizzato",
    message: "Non si dispone dei requisiti per accedere a questa pagina.",
    buttonText: "Torna Indietro",
  },
  notValidOnboarding: {
    title: "Controlla i tuoi dati",
    message:
      "Uno dei dati da te inseriti non è corretto.<br/> Torna indietro per modificare.",
    buttonText: "Torna Indietro",
  },
  errorMessages: {
    ERRFLOWOB001:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.",
    ERRFLOWOB003:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.",
    ERRFLOWOB004:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.",
    ERRFLOWOB005:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.",
    ERRFLOWOB006:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.",
    ERRFLOWOB007: "Errore sui dati immessi. Controlla i valori inseriti.",
    ERRFLOWOB008: "Errore sui dati immessi. Controlla i valori inseriti.",
    ERRFLOWOB009: "Check Validation Error", // Cambierà
    ERRFLOWOB010: "Data service error", // Eccezione workflow, tutto quello che è legato alla gestione workflow
    ERRFLOWOB011: "Onfido API Error", //Eccezione generata dalle API Onfido
    ERRFLOWOB012: "Document acquisition Error", //Eccezione generate in fase di creazione/update/gestione dei documenti di riconoscimento
    ERRFLOWOB013: "Errore sui dati immessi. Controlla i valori inseriti.", // Errore di validazione a seguito di chiamata servizi di validation
    ERRFLOWOB015:
      "Spiacenti, al momento non è possibile procedere. Riprovare più tardi.", // Errore sul controllo recaptha
    ERRFLOWOB017:
      "Pratica non trovata. Controlla che i dati inseriti siano corretti e riprova.",
    ERRFLOWOB024stepVerifyParentData: "Uno dei dati da te inseriti non è corretto.",
    ERRFLOWOB024stepVerifyEmailOtp: "Uno dei dati da te inseriti, non può essere utilizzato per procedere con l'apertura del conto.",
    errorPageMessage:
      "Si è verificato un errore imprevisto, per riprendere l'onboarding aggiorna la pagina. Se il problema persiste, riprova piu' tardi.",
    errorPageTitle: "Qualcosa è andato storto",
    refreshPage: "Aggiorna la pagina",
    default: "Si è verificato un errore",
  },
};

export const it: Record<string, string | object> = {
  ...componentsLocales,
  ...errorMessages,
};

// ERRFLOWOB001("Internal Error"), // Eccezione inaspettata e generica
// ERRFLOWOB003("Workflow error"), // Eccezione workflow, tutto quello che è legato alla gestione workflow
// ERRFLOWOB004("Template error"), // Errore in fase di parsing template che rappresenta lo step
// ERRFLOWOB006("Grpc client error"), // Errore di connessione ai microservizi sul cluster
// ERRFLOWOB007("Internal Validation Error"), // Errore non recuperabile durante la validazione
// ERRFLOWOB008("Validation Error"), // Error recuperabile causato da input utente ed intercettato dal validator
// ERRFLOWOB009("Check Validation Error"), // Cambierà
// ERRFLOWOB010("Data service error"), // Eccezione workflow, tutto quello che è legato alla gestione workflow
// ERRFLOWOB011("Onfido API Error"), //Eccezione generata dalle API Onfido
// ERRFLOWOB012("Document acquisition Error"), //Eccezione generate in fase di creazione/update/gestione dei documenti di riconoscimento
// ERRFLOWOB013("Business Validation Error"); // Errore di validazione a seguito di chiamata servizi di validation
